import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { MailWarning, RotateCw, Trash2 } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });

export function EmailFailuresPanel() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/email-failures").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, []);
  if (!items.length) return null;
  const resend = async (ids) => {
    setBusy(true);
    try {
      const r = await api.post("/email-failures/resend", { ids });
      if (r.data.sent) toast.success(`${r.data.sent} email reinviat${r.data.sent === 1 ? "a" : "e"}`);
      if (r.data.failed) toast.error(`${r.data.failed} non partit${r.data.failed === 1 ? "a" : "e"} di nuovo: controlla la casella Aruba`);
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const remove = async (ids) => {
    try { await api.post("/email-failures/delete", { ids }); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <section data-testid="email-failures-panel" className="rounded-xl border border-red-500/40 bg-red-500/5 p-3 sm:p-4 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <MailWarning className="w-4 h-4 text-red-400" />
        <h3 className="font-semibold text-red-200 flex-1">Email non partite ({items.length})</h3>
        <Button size="sm" disabled={busy} data-testid="email-failures-resend-all" onClick={() => resend(items.map((f) => f.id))}
          className="bg-red-500 hover:bg-red-600 text-white font-semibold"><RotateCw className={`w-4 h-4 mr-1 ${busy ? "animate-spin" : ""}`} />Reinvia tutte</Button>
      </div>
      <div className="space-y-1.5 max-h-60 overflow-y-auto">
        {items.map((f) => (
          <div key={f.id} data-testid={`email-failure-${f.id}`} className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-900/60 px-3 py-2 text-sm">
            <div className="flex-1 min-w-0">
              <p className="truncate"><span className="text-slate-500 font-mono text-xs mr-2">{fmt(f.at)}</span><b>{f.to}</b> · {f.subject}</p>
              <p className="truncate text-xs text-red-300/80">{f.error}</p>
            </div>
            {f.can_resend && (
              <Button size="sm" variant="outline" disabled={busy} data-testid={`email-failure-resend-${f.id}`} onClick={() => resend([f.id])}
                className="h-7 px-2 border-slate-700"><RotateCw className="w-3.5 h-3.5 mr-1" />Reinvia</Button>
            )}
            <Button size="sm" variant="ghost" data-testid={`email-failure-delete-${f.id}`} onClick={() => remove([f.id])} title="Elimina dall'elenco"
              className="h-7 w-7 p-0 text-slate-500 hover:text-red-300"><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
        ))}
      </div>
    </section>
  );
}
